import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import MenusLocationsListItem from './menus-locations-list-item/menus-locations-list-item.component';

type MenusLocationsListProps = {
  stores: { storeId: string; title: string }[];
};

const MenusLocationsList = ({ stores }: MenusLocationsListProps) => {
  const { t } = useTranslation();

  return (
    <Box data-testid="MenusLocations.List" my={3}>
      <Typography variant="h2">
        {t('drawer.menusDetailsDrawer.locations.title')}
      </Typography>
      {stores.map(store => (
        <MenusLocationsListItem key={store?.storeId} location={store} />
      ))}
    </Box>
  );
};

export default MenusLocationsList;
